module.exports = __webpack_public_path__ + "img/wms-b.c717a82c.svg";